<template>
    <zen-one
    :showuserinfo="false"
    title="CMS Ibayaq"
    :crumbs="crumbs"
    >
    <z-page
    title="Pengurusan Ibayaq - Pengumuman"
    >
  
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white">
      <template #title>
        Pengumuman
      </template>
  
      <w-form
        ref="form"
        v-model="dialog.valid"
        @validate="submitContent"
        @success="success"
      >
      <ckeditor :editor="editor" label="Content*" v-model="form.content" :config="editorConfig"></ckeditor>
      <w-input
            type="date"
            label="Tarikh Mula*"
            name="tarikh_mula"
            v-model="form.tarikh_mula"
            :validators="[validators.required]"
        />
        <w-input
            type="date"
            label="Tarikh Tamat*"
            name="tarikh_tamat"
            v-model="form.tarikh_tamat"
            :validators="[validators.required]"
        />
      </w-form>
  
  
      <template #actions>
        <div class="spacer" />
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
        <w-button
        class="ml1"
        :loading="dialog.loading"
        @click="$refs.form.validate()"
        >
          Simpan
        </w-button>
      </template>
  
  
    </w-dialog>
  
    <z-table
      ref="tbluser"
      title="Senarai Pengumuman"
      :headers="table.headers"
      :items="table.items"
      :meta="table.meta"
      class="white--bg"
    >
  
      <template #button>
        <w-button
        dark
        class="indigo-dark2--bg ml1 fs-2"
        @click="newrecordContent()"
        >
          <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta
        </w-button>
      </template>
  
      <template #header-label="{ header, label, index }">
        <template v-if="header.key == 'action'">
        <w-icon>fal fa-pencil</w-icon>
        </template>
        <template v-else>
        {{ label }}
        </template>
  
      </template>
  
      <template #item-cell.icon="{ item, label, header, index }">
        <w-icon md class="mr1" >{{ item.icon }}</w-icon>
      </template>
  
      <template #item-cell.action="{ item, label, header, index }">
        <w-flex class="flex justify-center">
          <w-button class="bs fs-2" bg-color="primary-dark1" tile @click="editContent(item.id)">
            <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
          </w-button>
          <w-button class="fs-2" bg-color="error-dark1" dark tile @click="removePengumuman(item.id)">
            <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
          </w-button>
        </w-flex>
      </template>
  
    </z-table>
  
    </z-page>
    </zen-one>
  </template>
  
  <script>
  import ZResource from "@/Modules/z-resource-service";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  
  export default {
    extends: ZResource,
    props: {
      items: [Array, Object],
    },
    data() {
      return {
        resourceurl: this.service_ibayaq + "cms/pengumuman",
        editor: ClassicEditor,
        reload: true,
        crumbs: [
          { label: this.$page.props.app_name, route: '/sitemap' },
          // { label: 'Utama', route: '/' },
          { label: 'Pengurusan Ibayaq', route: '/ibayaq_cms/pengumuman' },
          { label: 'Pengumuman', route: '/ibayaq_cms/pengumuman' }
        ],
        form: {
          id: 0,
          content: '',
          sendtype: 'new',
        },
        editorConfig: {
            width: '500px'
        },
      }
    },
    methods: {
        newrecordContent(){
            this.form = {
                id: 0,
                content: '',
                sendtype: 'new',
            };
            this.dialog.show = true;
        },
        editContent(id){
            this.loading = true;
            this.$zcomm.get(this.service_ibayaq + "cms/pengumuman/detail/" + id).then(resp => {
                this.form = resp;
                this.form.sendtype = 'update';
            });
            this.dialog.show = true;
            this.loading = false;
            
        },
        submitContent(){
            this.loading = true;
            // console.log(this.form);
            this.$zcomm.post(this.service_ibayaq + "cms/laman_utama/savepengumumansingle", this.form)
            .finally(() => {
                this.dialog.loading = false;
                location.reload();
            });
            
        },
        removePengumuman(id){
            this.$zcomm.get(this.service_ibayaq + "cms/laman_utama/removepengumuman/" + id).then(resp => {
                location.reload();
            });
        },
    },
    watch: {
    },
    mounted() {
      // override default setting
      this.dialog.width = 500
  
    },
  }
  </script>
  